var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Headers, URLSearchParams } from '@angular/http';
import { throwError, forkJoin, of } from 'rxjs';
import { catchError, flatMap, map, tap } from 'rxjs/operators';
import { Api } from 'app/core/api.service';
import { difference, first } from 'app/core/array/functions';
import { UserSettingsService } from 'app/user/user-settings.service';
import { toObject } from 'app/core/object/functions';
import * as i0 from "@angular/core";
import * as i1 from "../core/api.service";
import * as i2 from "../user/user-settings.service";
function formatError(errorResponse) {
    if (errorResponse.status === 400) {
        var json = errorResponse.json();
        var error = json.errorDescription || json.message || errorResponse.toString();
        return throwError(error);
    }
    return throwError(errorResponse.toString());
}
export var APPLICATIONS_COUNT = 10000;
var ApplicationsService = /** @class */ (function () {
    function ApplicationsService(_api, _userSettingsService) {
        this._api = _api;
        this._userSettingsService = _userSettingsService;
        this.allApplications = {};
    }
    ApplicationsService.prototype.applications = function (serviceType) {
        if (serviceType === void 0) { serviceType = this._userSettingsService.serviceType; }
        return Object.values(this.allApplications).filter(function (application) { return application.type === serviceType; });
    };
    ApplicationsService.prototype.defaultApplication = function (serviceType) {
        if (serviceType === void 0) { serviceType = this._userSettingsService.serviceType; }
        var defaultApplication = this._userSettingsService.defaultApplications[serviceType];
        var application = defaultApplication && this.find(defaultApplication.id);
        if (!application || application.type !== serviceType) {
            return (this._userSettingsService.defaultApplication = first(this.applications(serviceType)));
        }
        return application;
    };
    ApplicationsService.prototype.headers = function (applicationId) {
        if (applicationId === void 0) { applicationId = this.defaultApplication().id; }
        var headers = new Headers();
        headers.set('ACS-Application', applicationId);
        return headers;
    };
    ApplicationsService.prototype.init = function () {
        var _this = this;
        return this.getApplications().pipe(map(function (applications) { return applications || []; }), flatMap(function (applications) {
            var requiredTypes = ['ic', 'dc'];
            var existingTypes = applications.map(function (application) { return application.type; });
            var missingTypes = difference(requiredTypes, existingTypes);
            if (missingTypes.length === 0) {
                return of(applications);
            }
            return forkJoin(missingTypes.map(function (type) {
                if (type === 'dc') {
                    return _this.createApplication('Other Documents Demo', type);
                }
                else {
                    return _this.createApplication('Invoices Demo', type);
                }
            })).pipe(map(function (createdApplications) { return applications.concat(createdApplications); }));
        }), tap(function (applications) {
            return (_this.allApplications = toObject(applications, function (app) { return app.id; }));
        }));
    };
    ApplicationsService.prototype.search = function (query) {
        var _this = this;
        return this.applications().filter(function (app) {
            return _this.filterRows(app, query);
        });
    };
    ApplicationsService.prototype.getApplicationsCount = function () {
        var params = new URLSearchParams();
        params.set('type', this._userSettingsService.serviceType);
        return this._api.get('/v2/applications/count', { params: params });
    };
    ApplicationsService.prototype.filterRows = function (app, query) {
        var _query = query.toLowerCase();
        return (app.name.toLowerCase().includes(_query) ||
            app.id.toLowerCase().includes(_query) ||
            app.project.toLowerCase().includes(_query) ||
            (app.tenant && app.tenant.toLowerCase().includes(_query)));
    };
    ApplicationsService.prototype.searchByName = function (query) {
        return this.applications().filter(function (app) {
            return app.name.toLowerCase().includes(query.toLowerCase());
        });
    };
    ApplicationsService.prototype.find = function (id) {
        return this.allApplications[id];
    };
    ApplicationsService.prototype.setDefault = function (application) {
        this._userSettingsService.defaultApplication = application;
    };
    ApplicationsService.prototype.getApplications = function (serviceType, search, includeDeleted, skip, take // TODO(AKryuchkov): Плохо так делать. Сделать пагинацию на бэке
    ) {
        if (serviceType === void 0) { serviceType = null; }
        if (search === void 0) { search = null; }
        if (includeDeleted === void 0) { includeDeleted = 'false'; }
        if (skip === void 0) { skip = 0; }
        if (take === void 0) { take = APPLICATIONS_COUNT; }
        var params = new URLSearchParams();
        params.set('type', serviceType);
        params.set('search', search);
        params.set('take', "" + take);
        params.set('skip', "" + skip);
        params.set('includeDeleted', includeDeleted);
        return this._api.get('/v2/applications/', { params: params });
    };
    ApplicationsService.prototype.generateBasicAuthHeaders = function (login, password) {
        var credentials = login + ":" + password;
        var headers = new Headers();
        headers.set('authorization', "Basic " + btoa(credentials));
        return headers;
    };
    ApplicationsService.prototype.getProjects = function (tenant, login, password) {
        return this._api.get("/v2/application/projects/" + tenant, {
            headers: this.generateBasicAuthHeaders(login, password)
        });
    };
    ApplicationsService.prototype.createApplication = function (name, type) {
        var _this = this;
        return this._api
            .post('/v2/application/', { name: name, type: type })
            .pipe(tap(function (application) { return (_this.allApplications[application.id] = application); }));
    };
    ApplicationsService.prototype.deleteApplication = function (id) {
        var _this = this;
        return this._api.delete("/v2/application/" + id).pipe(tap(function () {
            var application = _this.defaultApplication();
            delete _this.allApplications[id];
            if (application.id === id) {
                _this._userSettingsService.defaultApplication = first(_this.applications());
            }
        }));
    };
    ApplicationsService.prototype.restetToken = function (id) {
        return this._api
            .put("/v2/application/token", { id: id })
            .pipe(tap(this.updateApplication.bind(this)));
    };
    ApplicationsService.prototype.renameApplication = function (id, name) {
        return this._api
            .put("/v2/application/name", { id: id, name: name })
            .pipe(tap(this.updateApplication.bind(this)));
    };
    ApplicationsService.prototype.copyApplication = function (id) {
        var _this = this;
        var headers = new Headers();
        headers.set('content-type', 'application/javascript');
        return this._api
            .post("/v2/application/clone", { ApplicationId: id }, { headers: headers })
            .pipe(tap(function (application) { return (_this.allApplications[application.id] = application); }));
    };
    ApplicationsService.prototype.updateApplication = function (application) {
        this.allApplications[application.id] = Object.assign(this.allApplications[application.id], application);
    };
    ApplicationsService.prototype.updateApplications = function (applications) {
        var _this = this;
        applications.map(function (application) {
            _this.allApplications[application.id] = __assign({}, application);
        });
    };
    ApplicationsService.prototype.findUserApplications = function (email) {
        var params = { owner: email };
        var skip = 0;
        var take = APPLICATIONS_COUNT; // TODO(AKryuchkov): Плохо так делать. Сделать пагинацию на бэке
        return this._api
            .get("/v2/system/applications/" + skip + "/" + take, { params: params })
            .pipe(catchError(formatError));
    };
    ApplicationsService.prototype.updateBinding = function (application) {
        var _this = this;
        var body = {
            id: application.id,
            tenant: application.binding.tenant,
            project: application.binding.project,
            user: application.binding.user,
            password: application.binding.password,
            is_realtime: application.binding.isRealtime
                ? application.binding.isRealtime
                : false
        };
        return this._api.put('/v2/system/application/binding/', body).pipe(tap(function () {
            if (application.type === 'ic') {
                _this._api
                    .post("/v2/system/dataset/rebind/", { application: application.id }, { headers: _this.headers() })
                    .subscribe();
            }
        }));
    };
    ApplicationsService.prototype.bindingApplication = function (binding) {
        var _this = this;
        var body = {
            id: binding.id,
            tenant: binding.tenant,
            project: binding.project,
            user: binding.user,
            password: binding.password
        };
        return this._api
            .put('/v2/application/binding/', body)
            .pipe(tap(function (application) { return (_this.allApplications[application.id] = application); }));
    };
    ApplicationsService.ngInjectableDef = i0.defineInjectable({ factory: function ApplicationsService_Factory() { return new ApplicationsService(i0.inject(i1.Api), i0.inject(i2.UserSettingsService)); }, token: ApplicationsService, providedIn: "root" });
    return ApplicationsService;
}());
export { ApplicationsService };
